import { Component, Input } from '@angular/core';

@Component({
    selector: 'fdx-page-title',
    templateUrl: './page-title.component.html',
    styleUrl: './page-title.component.scss',
    standalone: false
})
export class PageTitleComponent {
    @Input() classes: Record<string, boolean> = null;

    @Input() beta?: boolean = false;
    @Input() darkBackground?: boolean = false;

    get betaBadgeClasses(): string {
        if (this.darkBackground) {
            return 'badge text-bg-outline-discovery';
        }
        return 'badge text-bg-discovery'
    }
}
